import React, { Component } from 'react';
import {connect} from 'react-redux';
import {fetchPosOrder, clearPosOrder, getPosConfig} from '../../actions/pos';
import Spinner from '../shared/spinner';
import MemberInfo from '../shared/memberInfo';
import viewHelper from '../../helpers/view';
import CacheService from '../../services/cacheService';
import defaultImage from '../../assets/images/default.jpg'

class PosOrder extends Component {

    componentDidMount() {
        if(!this.props.posOrder) {
            this.props.fetchPosOrder(this.props.match.params.order_id).then(() => {
                this.props.getPosConfig(this.props.member.site_id);
            })
        }
    }

    componentWillUnmount() {
        this.props.clearPosOrder();
    }

    shopAgain() {
        window.location.reload();
    }

    goToHome() {
        this.props.history.push(`/${CacheService.getToken().bname}/`);
    }

    getPosOrderItems() {
        let items = this.props.posOrder.items;
        return items.map((item) => {
           return (
               <tr key={item.id}>
                   <td>{item.quantity}</td>
                   <td>{item.description}</td>
                   <td className='text-right'>{viewHelper.formatCurrency(item.total, this.props.currency)}</td>
               </tr>
           )
        });
    }

    render () {
        let { member, posOrder, currency, siteAddress } = this.props;
        if(posOrder && currency && siteAddress) {
            return (
                <div className="container content">
                    <MemberInfo title={`${viewHelper.getFullName(member)} - Order Receipt`} />
                    <div className='col-xs-12 col-lg-4'/>
                    <div className='col-xs-12 col-lg-4'>
                        {this.props.appointment && <div className='text-center appointment-message'>
                            Your appointment is now confirmed. An email has been sent
                        </div>}
                        <div className='receipt-header text-center'>
                            <img src={this.props.siteUrl || defaultImage} alt=""/>
                            <h4>{CacheService.getToken().bname}</h4>
                        </div>
                        <div className='receipt-total text-center'>
                            {viewHelper.formatCurrency(posOrder.total, currency)}
                        </div>
                        <table className='table table-condensed receipt-content'>
                            <thead>
                                <tr>
                                    <th>Qty.</th>
                                    <th>Description</th>
                                    <th className='text-right'>Totals</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.getPosOrderItems()}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan='2' className='text-right'>SubTotal</th>
                                    <th className='text-right'>{viewHelper.formatCurrency(parseFloat(posOrder.total) - parseFloat(posOrder.tax), currency)}</th>
                                </tr>
                                <tr>
                                    <th colSpan='2' className='text-right'>Tax</th>
                                    <th className='text-right'>{viewHelper.formatCurrency((posOrder.tax), currency)}</th>
                                </tr>
                                <tr>
                                    <th colSpan='2' className='text-right'>Discount</th>
                                    <th className='text-right'>{viewHelper.formatCurrency((posOrder.discount), currency)}</th>
                                </tr>
                                <tr>
                                    <th colSpan='2' className='text-right'>Total</th>
                                    <th className='text-right'>{viewHelper.formatCurrency((posOrder.total), currency)}</th>
                                </tr>
                            </tfoot>
                        </table>

                        <div className='text-muted text-center receipt-message'>
                            <div>{this.props.receiptMessage.line1}</div>
                            <div>{this.props.receiptMessage.line2}</div>
                            <div>{this.props.receiptMessage.line3}</div>
                            <div>{this.props.receiptMessage.line4}</div>
                            <div>{this.props.receiptMessage.line5}</div>
                        </div>

                        <table className='table receipt-info'>
                            <tbody>
                            <tr>
                                <td>Receipt No: {posOrder.id}</td>
                                <td className='text-right'>Member No: {member.member_no}</td>
                            </tr>
                            <tr>
                                <td colSpan='2' className='text-right'>{viewHelper.getFormattedDateTime(posOrder.sale_date)}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div className='receipt-footer text-center'>
                            <h4>{CacheService.getToken().bname}</h4>
                            <div>{siteAddress.address}</div>
                            <div>{`${siteAddress.city} ${siteAddress.state}, ${siteAddress.zip}`}</div>
                            <p className='mt-10'>&copy; Coral Springs Software</p>
                        </div>

                    </div>
                    <div className='col-xs-12 col-lg-4 text-right pt-15'>
                        <button className='btn btn-primary mr-15' onClick={this.shopAgain.bind(this)}>Shop Again</button>
                        <button className='btn btn-primary' onClick={this.goToHome.bind(this)}>Home</button>
                    </div>
                </div>
            )
        } else {
            return (
                <div className='container content'>
                    <Spinner />
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    const { posOrder, posConfig } = state;
    if(posOrder && posConfig && posConfig.site) {
        return {
            posOrder: posOrder,
            currency: posConfig.currency,
            siteLogo: posConfig.site.logo,
            siteAddress: posConfig.site.address,
            receiptMessage: posConfig.receipt_message
        };
    } else {
        return {};
    }
}

export default connect(mapStateToProps, { fetchPosOrder, clearPosOrder, getPosConfig })(PosOrder);
